<template>
  <b-popover placement="bottom" :title="modalTitle" triggers="click" :target="target">
    <b-form class="wd-invoice-creation-form" @submit.prevent="createAndRedirect">
      <fields-mapper-invoice-creation v-model="invoiceData" :fields-mapper="fieldsMapper" />
      <hr class="wd-invoice-creation-form__divider">
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" type="submit">
          {{ $t('buttons.common.create') }}
        </b-btn>
      </div>
    </b-form>
  </b-popover>
</template>

<script>
import FieldsMapperInvoiceCreation from '@/components/common/purchase-invoices/FieldsMapperInvoiceCreation'
import { mapGetters } from 'vuex'
import { notificationsRenderer } from '@/helpers/renderHelpers'
import { setNotifyData } from '@/helpers/commonHelpers'

export default {
  name: 'PurchaseInvoiceCreationPopover',
  components: {
    FieldsMapperInvoiceCreation
  },
  props: {
    target: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      invoiceData: {
        invoice_sum: '',
        operation: null,
        contract: null
      }
    }
  },
  methods: {
    async createAndRedirect () {
      try {
        const payload = {
          invoice_sums_difference: this.invoiceData.invoice_sum,
          movement_id: this.invoiceData.operation?.id,
          contract_id: this.invoiceData.contract?.id
        }
        const { data: { id } } = await this.$http.post(`accounting/purchase_invoices/create_by_operation/`, payload)
        this.$notify(setNotifyData(
          this.$i18n.t(`notifications.common.created`),
          this.$i18n.t(`common_content.purchase_invoice`),
          'success'
        ))
        await this.$router.push({ name: 'Purchase Invoice', params: { id } })
      } catch (e) {
        notificationsRenderer(e.body, 'error')
      }
    }
  },
  computed: {
    ...mapGetters('operations', ['operationsList']),
    ...mapGetters('contracts', ['relatedContracts']),
    modalTitle () {
      return `${this.$i18n.t('buttons.common.create')} ${this.$i18n.t('common_content.invoice')}`
    },
    isContractDisabled () {
      return !this.invoiceData.operation
    },
    fieldsMapper () {
      return [
        {
          type: 'input',
          key: 'invoice_sum',
          required: true,
          labelText: 'Invoice sum',
          placeholder: 'Enter invoice sum'
        },
        {
          type: 'multiselect',
          key: 'operation',
          label: 'name',
          required: true,
          trackBy: 'id',
          options: this.operationsList,
          labelText: 'Operation',
          placeholder: 'Choose operation'
        },
        {
          type: 'multiselect',
          key: 'contract',
          label: 'contract_nr',
          trackBy: 'id',
          disabled: this.isContractDisabled,
          options: this.relatedContracts,
          labelText: 'Contract',
          placeholder: 'Choose related contract'
        }
      ]
    }
  },
  mounted () {
    this.$root.$on('openPurchaseInvoiceCreationModal', async () => {
      await this.$store.cache.dispatch(
          'operations/findListOperations',
          {
            params: { process: 1, status: 'P' },
            url: 'woodware/search_for_unbounded_movement_list/'
          }
      )
    })
  },
  beforeDestroy () {
    this.$root.$off('openPurchaseInvoiceCreationModal')
  }
}
</script>

<style lang="sass" scoped>
.wd-invoice-creation-form
  width: 350px

  &__divider
    // horizontal margin are for form paddings compensation
    margin: 10px -0.75rem
</style>


// WEBPACK FOOTER //
// src/components/common/purchase-invoices/PurchaseInvoiceCreationPopover.vue